import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import Modal from "react-modal";
import moment from "moment";

const AtmosphereStorageList = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const { addForm, update ,sId} = props;
  const [data, setData] = useState([]);
  const [casData, setCasData] = useState([]);
  const [allData, setAllData] = useState([]);

  const { sendRequest: getCas } = useHttp();

  useEffect(() => {
    getCas(
      {
        url: `/api/ControlAtmosStorage/?warehouseId=${localStorage.getItem(
          "warehouseId"
        )}`,
      },
      (res) => {
        if (res) {
          const sortedData = res.sort((a, b) => b.casId - a.casId);
          setData(sortedData);
          // //console.log(res);
          setCasData(res[0]);
          setAllData(res);
        }
      }
    );
  }, [getCas]);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.casNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);

    const id = data && data.casId;
    if (id) {
      getCas(
        {
          url: `/api/ControlAtmosStorage/?orgId=${localStorage.getItem(
            "orgId"
          )}&casId=${id}`,
        },
        (res) => {
          if (res) {
            //console.log(res);
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Controlled Atmosphere Storage
            </label>
          </div>

          <div className="col-6 text-right">
            <button
              type="button"
              className="btn  btn-primary mx-3 my-3"
              onClick={() => {
                addForm(true);
                sId(serviceId)
                props.update(false);
              }}
            >
              Add Atmosphere Storage
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Doc No</th>
                          <th>Assigned Supervisor</th>
                          <th>Chamber Temperature</th>
                          {canEdit === "block" && <th>Edit</th>}
        {canDelete === "block" && <th>Delete</th>}
        {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.casDate}</td>
                                <td>{itm.casNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.chamberTemperature}</td>
                                {canEdit === "block" && (
                                <td>
                                  <button
                                    onClick={() => {
                                      props.addForm(true);
                                      sId(serviceId)
                                      props.update(itm);
                                    }}
                                    className="btn"
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>)}
                                {canDelete === "block" && (
                                <td>
                                  <button
                                    type="button"
                                    // onClick={(e) => handleDelete(e, itm)}
                                    className="btn"
                                  >
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>)}
                                {canView === "block" && (
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(itm)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>)}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Control Atmosphere Storage Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Control Atmosphere Storage No: {selectedData.casNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Control Atmosphere Storage Date: {selectedData.casDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Assign Supervisor: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                TimeStamp:
                {moment(selectedData.timeStamp, "HH:mm:ss").format("hh:mm A")}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Chamber Temperature(°C): {selectedData.chamberTemperature}
              </p>
            </div>

            <br />
            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered table-responsive table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Product Name</th>
                  <th>Item Id</th>
                  <th>Batch</th>

                  <th>Quantity</th>

                  <th>Temperature</th>
                  <th>Obsv.Count</th>
                  <th>O2%</th>
                  <th>CO2%</th>
                  <th>Sucrose%</th>

                  <th>Reducing Sugars(RS)</th>
                  <th>Total Sugars(TS)</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productData &&
                  selectedData.productData.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.batchId}</td>

                        <td>{itm.quantity}</td>
                        <td>{itm.temperature}</td>
                        <td>{itm.obsvCount}</td>
                        <td>{itm.o2}</td>
                        <td>{itm.co2}</td>
                        <td>{itm.sucrose}</td>
                        <td>{itm.reducingSugars}</td>
                        <td>{itm.totalSugars}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
        )}
      </Modal>
    </>
  );
};

export default AtmosphereStorageList;
